export default {
    name: 'NUCO',
    logoVariant: 'dark',
    logo: {
        square: '/src/brands/nuco/assets/square.png',
    },
    pwa: {
        name: 'NUCO Resort Management',
        shortName: 'NUCO Snowfuze',
        themeColor: '#642b3b',
        backgroundColor: '#ffffff',
        icon: '/src/brands/nuco/assets/icon.png',
        vapidPublicKey: 'BO6LHTcktRG1xwi5WAKtKKzmOy-Y4v1rr0Etqw8gXY5vYolkQATa1iHs_pq44R8XVOGm1UaI-lurI_ggeZQxv2E'
    }
}